// Run… — the Start-menu Run dialog, for real. Program names open windows (cmd, notepad, mspaint,
// iexplore, wmplayer, msnmsgr, pinball, winmine, doom…), URLs open in the Time Machine, and a few
// commands answer in-character. Community ask 2026-09-08: "Start Menu: … Run" + "secret Run commands".
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import runIcon from 'assets/windowsIcons/743(32x32).png';
import { findGame, openGame } from '../Games/catalog';
import { BASEMENT_KEY, isUnlocked } from '../Basement/state';
import { LIVE as CASINO_LIVE, PRACTICE as CASINO_PRACTICE } from 'lib/casino';

const PROGRAMS = {
  cmd: 'Command Prompt', command: 'Command Prompt', terminal: 'Command Prompt', python: 'Command Prompt',
  notepad: 'Notepad', readme: 'Notepad', mspaint: 'Paint', paint: 'Paint', pbrush: 'Paint',
  iexplore: 'Internet Explorer', ie: 'Internet Explorer', internet: 'Internet Explorer',
  timemachine: 'Time Machine', wayback: 'Time Machine',
  wmplayer: 'Windows Media Player', mplayer2: 'Windows Media Player', movies: 'Windows Media Player',
  msnmsgr: 'Windows Messenger', msmsgs: 'Windows Messenger', msn: 'Windows Messenger', messenger: 'Windows Messenger',
  pinball: 'Pinball', '3dpinball': 'Pinball', winmine: 'Minesweeper', minesweeper: 'Minesweeper',
  winamp: 'Winamp', games: 'Games', explorer: 'My Computer', mycomputer: 'My Computer',
  payday: 'Payday', msft: 'Msft', verify: 'Verify', mission: 'Mission', dividends: 'Dividends', buy: 'Buy',
  network: 'Network', 'ncpa.cpl': 'Network', recycle: 'Recycle Bin', videos: 'My Videos', myvideos: 'My Videos',
  zone: 'Zone', flags: 'Zone', minesweeperflags: 'Zone',
};
const SUGGEST = ['casino', 'cmd', 'notepad', 'mspaint', 'iexplore', 'wmplayer', 'msnmsgr', 'pinball', 'winmine', 'zone', 'doom', 'skifree', 'games', 'payday'];
const HISTORY_KEY = 'ic:run:history';

function open(detail) {
  window.dispatchEvent(new CustomEvent('ic:open', { detail }));
}
function error(message) {
  open({ app: 'Error', props: { message } });
}

export function runCommand(raw) {
  const line = String(raw || '').trim();
  if (!line) return false;
  const key = line.toLowerCase().replace(/\.exe$/, '').replace(/\s+/g, '');
  if (key === 'casino') {
    if (CASINO_LIVE || CASINO_PRACTICE) open('Casino');
    else error('CASINO.exe\n\nThe floor is not open yet. The cabinets are built and tested, not deployed.');
    return true;
  }
  if (PROGRAMS[key]) {
    open(PROGRAMS[key]);
    return true;
  }
  if (key === 'basement' || key === 'basement.exe') {
    if (isUnlocked()) open('Basement');
    else error("Windows cannot find 'basement'. Make sure you typed the name correctly, and then try again.\n\n(the door is on the internal web, fren. Internet Explorer.)");
    return true;
  }
  if (key === BASEMENT_KEY) {
    error(isUnlocked() ? 'that key already turned. BASEMENT.exe is on the desktop.' : "that's a key, not a program.\n\nthe door is in Internet Explorer.");
    return true;
  }
  if (/^(sol|solitaire|freecell|spider|hearts)$/.test(key)) {
    error('Solitaire is not installed on this machine.\n\n(yet. the lobby asked. we heard.)');
    return true;
  }
  if (key === 'regedit') { error('The internet has no registry.\n\nnothing to edit. nothing to break. we hold.'); return true; }
  if (key === 'calc') { error('Calculator is not installed.\n\nopen cmd and type PYTHON. it does math.'); return true; }
  if (key === 'shutdown' || key === 'logoff') { error('The internet does not turn off.'); return true; }
  if (key === 'telnet' || key.startsWith('telnet')) { error("telnet is for the other basement.\n\ntry cmd → 'tracert internetcoin.vip'."); return true; }
  const g = findGame(line);
  if (g) {
    openGame(g);
    return true;
  }
  if (/^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)+(\/\S*)?$/i.test(line)) {
    const url = line.replace(/^https?:\/\//i, '');
    if (/^(www\.)?internetcoin\.vip\/?$/i.test(url)) open('Internet Explorer');
    else open({ app: 'Internet Explorer', props: { startUrl: url, startYear: 2003 }, title: `${url} - Internet Explorer` });
    return true;
  }
  error(`Windows cannot find '${line}'. Make sure you typed the name correctly, and then try again. To search for a file, click the Start button, and then click Search.`);
  return true;
}

function Run({ onClose }) {
  const [value, setValue] = useState('');
  const [history, setHistory] = useState(() => {
    try { return JSON.parse(localStorage.getItem(HISTORY_KEY) || '[]'); } catch (e) { return []; }
  });
  const inputRef = useRef(null);
  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();
  }, []);

  function ok() {
    const v = value.trim();
    if (!v) return;
    const next = [v, ...history.filter(h => h !== v)].slice(0, 10);
    setHistory(next);
    try { localStorage.setItem(HISTORY_KEY, JSON.stringify(next)); } catch (e) { /* private mode */ }
    runCommand(v);
    onClose();
  }
  function onKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); ok(); }
    else if (e.key === 'Escape') onClose();
  }

  return (
    <Div>
      <div className="run__top">
        <img src={runIcon} alt="" className="run__icon" />
        <p>Type the name of a program, folder, document, or Internet resource, and Windows will open it for you.</p>
      </div>
      <div className="run__row">
        <label htmlFor="ic-run-input">Open:</label>
        <input
          id="ic-run-input"
          ref={inputRef}
          list="ic-run-list"
          value={value}
          onChange={e => setValue(e.target.value)}
          onKeyDown={onKeyDown}
          autoComplete="off"
          spellCheck={false}
        />
        <datalist id="ic-run-list">
          {[...history, ...SUGGEST.filter(s => !history.includes(s))].map(s => <option key={s} value={s} />)}
        </datalist>
      </div>
      <div className="run__buttons">
        <div className="run__button" onClick={ok}>OK</div>
        <div className="run__button" onClick={onClose}>Cancel</div>
        <div className="run__button" onClick={() => { open('My Computer'); onClose(); }}>Browse...</div>
      </div>
    </Div>
  );
}

const Div = styled.div`
  background: #ece9d8;
  width: 100%;
  font-size: 11px;
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  .run__top { display: flex; gap: 12px; align-items: flex-start; p { margin: 2px 0 0; line-height: 1.4; color: #000; } }
  .run__icon { width: 32px; height: 32px; flex-shrink: 0; }
  .run__row { display: flex; align-items: center; gap: 10px; label { width: 32px; }
    input { flex: 1; height: 21px; border: 1px solid #7f9db9; padding: 0 4px; font: inherit; font-size: 11px; outline: none; background: #fff; } }
  .run__buttons { display: flex; justify-content: flex-end; gap: 6px; }
  .run__button { width: 74px; height: 22px; display: flex; align-items: center; justify-content: center; border: 1px solid #003c74; border-radius: 3px; background: linear-gradient(#fff, #ecebe5); cursor: default; box-shadow: 0 1px 0 rgba(0,0,0,.15);
    &:hover { box-shadow: inset 0 0 0 1px #ffe9a8, inset 0 -3px 0 #f4c96a; }
    &:first-child { box-shadow: inset 0 0 0 1px #6ba3d9; } }
`;

export default Run;
